import React from 'react';
import SimpleProductPage from './PriceComparison/SimpleProductPage';
import { 
  findProductById, 
  getProductImage, 
  getProductCsvLookupId 
} from '../utils/productHelpers';

const SimpleHDIShuttle = () => {
  console.log('🎯 SimpleHDIShuttle component loading');
  
  const product = findProductById("hdi-shuttle");
  
  if (!product) {
    console.error('Product not found:', "hdi-shuttle");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="hdi-shuttle"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
    />
  );
};

export default SimpleHDIShuttle; 